document.addEventListener('cart:updated', function(evt) {
   setTimeout(function(){ 
  var cartTotal = evt.detail.cart.total_price;
  var fragtLimit = 99900;
  var fragtGap = (fragtLimit - cartTotal) / 100; 
  if (cartTotal < 10000) {
    document.querySelector(".drawer__shipping-inner").textContent = fragtGap + " kr tilbage til gratis fragt";
  	document.getElementById("fragtpris").textContent = "FRA 39 kr";
  }
  else if (cartTotal < 99900) {
    document.querySelector(".drawer__shipping-inner").textContent = fragtGap + " kr tilbage til gratis fragt";
  	document.getElementById("fragtpris").textContent = "FRA 29 kr";
  }
  else {
  	document.querySelector(".drawer__shipping-inner").textContent = "Du har opnået gratis fragt";
    document.getElementById("fragtpris").textContent = "GRATIS FRAGT";
  }
  }, 250);
  });

document.addEventListener('drawerOpen', function(evt) {
fetch('/cart.js')
  .then(response => response.json())
  .then(data => {
   	var cartTotal = data.total_price;
  	var fragtLimit = 99900;
  	var fragtGap = (fragtLimit - cartTotal) / 100; 
  	if (data.total_price < 10000) {
        document.querySelector(".drawer__shipping-inner").textContent = fragtGap + " kr tilbage til gratis fragt";
  		document.getElementById("fragtpris").textContent = "FRA 39 kr";
  	}
 	else if (data.total_price < 99900) {
  		document.querySelector(".drawer__shipping-inner").textContent = fragtGap + " kr tilbage til gratis fragt";
  		document.getElementById("fragtpris").textContent = "FRA 29 kr";
  	}
  	else {
   		document.querySelector(".drawer__shipping-inner").textContent = "Du har opnået gratis fragt";
  		document.getElementById("fragtpris").textContent = "GRATIS FRAGT";
  	}
   	});
  });

// Søgeredirect
function searchRedirect(searchTerm) {
var xmlhttp = new XMLHttpRequest();
var submitForm = true;
xmlhttp.open('GET', 'https://sheets.googleapis.com/v4/spreadsheets/1D0z2yzCvwIzPxLF0QjkeOa-s5MjcOr-06sUKD4Jdt7g/values/Ark1!A:B?alt=json&key=AIzaSyA2ClqOpO29oaOMz-WgjFdebc6VNhAPXew', false);
xmlhttp.onreadystatechange = function() {
    if (xmlhttp.readyState == 4) {
        if(xmlhttp.status == 200) {
            var data = JSON.parse(xmlhttp.responseText);
               var i;
               for (i = 0; i < data.values.length; i++) {
                    if (searchTerm.value.toLowerCase() == data.values[i][0]) {
                      window.location = "https://vikleliv.dk/" + data.values[i][1];
                      submitForm = false;
                      return;
                    };

                };
                }
        }
    }
xmlhttp.send(null);
  if (submitForm) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'search',
        'search_term': searchTerm.value.toLowerCase(),
        'search_type': 'search result page'
  });
  }
  else {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'search',
        'search_term': searchTerm.value.toLowerCase(),
        'search_type': 'search redirect'
  });
  }
return submitForm; 
};

// Youtube tracking
function select_youtube_link () {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'select_youtube_link',
    });
};
